import React from 'react';


// helpers
import {transformValueFloattoMoney} from "../../../helpers/formats"

export default function PenalidadesAplicadas({ penalidades }) {

    return (

        <div className="contentGroup">
            <h5 className="subtitleCardInfo">Penalidades Aplicadas</h5>
            {penalidades && penalidades.map((m, key) => {
                return <div key={key} className='mt-2'>
                    <strong>{m.tipoPenalidade}</strong><br/>
                    <span>{m.descricao + ": " + (m.tipoPenalidade == "Multa" ? transformValueFloattoMoney(m.valor) : m.advertencia)}</span>
                </div>
            })}
        </div>
    );
}
